import { initialise } from "@asosteam/asos-web-secure-script-container";
import clientConfig from "@template/clientConfig";

const { SECURE_SCRIPT_CONTAINER_DOMAIN } = clientConfig.get();

export default () => {
  initialise({ containerDomain: SECURE_SCRIPT_CONTAINER_DOMAIN });
};
